import { render, staticRenderFns } from "./mortarTank.vue?vue&type=template&id=1841034a&scoped=true"
import script from "./mortarTank.vue?vue&type=script&lang=js"
export * from "./mortarTank.vue?vue&type=script&lang=js"
import style0 from "./mortarTank.vue?vue&type=style&index=0&id=1841034a&prod&scoped=true&lang=css"
import style1 from "./mortarTank.vue?vue&type=style&index=1&id=1841034a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841034a",
  null
  
)

export default component.exports